/** Red dot color - #DD2727 (from design) */
export const FEATURE_DOT_COLOR = '#DD2727';

/**
 * Dot IDs for the current release. Update this list on each deployment
 * when you want to highlight different UI targets. Old IDs will be
 * pruned from user preferences when they are no longer in this list.
 */
export const CURRENT_RELEASE_FEATURE_DOT_IDS = [
  'entities-three-dots', // Entity row: 3-dots menu trigger
  'entities-pin', // Entity row: Pin option inside the 3-dots menu
  'vat-report-more-filters', // VAT report: + More Filters button
  'entities-reconciliation-tab', // Organisation: Reconciliation tab
  'entities-reconciliation-get-started', // Organisation: Reconcile your Tax Account Get Started button
  'entities-capture-tab', // Organisation: Capture Documents tab
  'entities-transactions-tab', // Organisation: Transactions tab
  'entities-new-entity-button', // Header: + New Entity button
  'entities-create-group-button', // Entities table: Create Group button
  'connect-entity-excel', // Connect Entity drawer: Excel/CSV Upload box
  'connect-entity-receipts', // Connect Entity drawer: AI Scan Receipts & Bills box
  'returns-map-with-ai', // Returns mapping: Map with AI button
  'design-gallery-feature-dot', // Design system doc page demo only (/dev/design-system/feature-dots)
] as const;

export type FeatureDotId = (typeof CURRENT_RELEASE_FEATURE_DOT_IDS)[number];

/** Max dismissed IDs to keep in preferences (avoids unbounded growth). */
export const DISMISSED_FEATURE_DOTS_MAX_SIZE = 15;
